module.exports = __webpack_public_path__ + "static/media/no-connection.39ed8a85.svg";